export default "<div id=\"map\" style=\"min-height: calc(100vh - 67px)\"></div>\n"